export default "__VITE_ASSET__f08b1b87__"